var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAuthority)?_c('el-button',_vm._b({attrs:{"size":_vm.size,"type":_vm.type,"loading":_vm.loading,"disabled":_vm.disabled,"hidden":_vm.hasAuthority},on:{"click":_vm.handleClick}},'el-button',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07b0f56a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buttons/permission-button.vue
// module id = null
// module chunks = 